import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";
import { checkFile } from "./DocSlot";

// ASO admissional: file + exam date + result (Apto/Inapto). Inapto blocks forwarding; nothing is cancelled automatically.
export function AsoDialog({ employeeId, open, onClose, onDone }) {
  const [f, setF] = useState({ file: null, exam_date: "", result: "", clinic: "", doctor: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ file: null, exam_date: "", result: "", clinic: "", doctor: "" }); }, [open]);
  const send = async () => {
    const bad = checkFile(f.file);
    if (bad) { toast.error(bad); return; }
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => v && fd.append(k, v));
    setBusy(true);
    try {
      const { data } = await api.post(`/admissions/by-employee/${employeeId}/aso`, fd);
      toast[f.result === "apto" ? "success" : "warning"](f.result === "apto" ? "ASO Apto registrado." : "ASO Inapto registrado. O encaminhamento fica bloqueado até a empresa decidir.");
      onDone(data); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="aso-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Registrar ASO admissional</DialogTitle>
          <DialogDescription>O exame deve ser anterior ao início das atividades e recente (até 90 dias). Somente ASO Apto libera o encaminhamento.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div><Label>Arquivo do ASO (PDF ou imagem)</Label><Input type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" className="mt-1" data-testid="aso-file" onChange={(e) => setF({ ...f, file: e.target.files?.[0] || null })} /></div>
          <div className="grid grid-cols-2 gap-2">
            <div><Label>Data do exame</Label><Input type="date" className="mt-1" value={f.exam_date} onChange={(e) => setF({ ...f, exam_date: e.target.value })} data-testid="aso-date" /></div>
            <div><Label>Resultado</Label><Select value={f.result} onValueChange={(v) => setF({ ...f, result: v })}><SelectTrigger className="mt-1" data-testid="aso-result"><SelectValue placeholder="Selecione" /></SelectTrigger>
              <SelectContent><SelectItem value="apto" data-testid="aso-result-apto">Apto</SelectItem><SelectItem value="inapto" data-testid="aso-result-inapto">Inapto</SelectItem></SelectContent></Select></div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div><Label>Clínica (opcional)</Label><Input className="mt-1" value={f.clinic} onChange={(e) => setF({ ...f, clinic: e.target.value })} data-testid="aso-clinic" /></div>
            <div><Label>Médico (opcional)</Label><Input className="mt-1" value={f.doctor} onChange={(e) => setF({ ...f, doctor: e.target.value })} data-testid="aso-doctor" /></div>
          </div>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose} disabled={busy}>Cancelar</Button>
          <Button onClick={send} disabled={busy || !f.file || !f.exam_date || !f.result} data-testid="aso-submit">{busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}Registrar ASO</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}
